export class SeoContentFor {
    //-- SeoContentFor Job Search--
    public static SimpleJobSearch = 1;
    public static JobSearchByLocation = 5;
    public static JobSearchByIndustry = 3;
    //-- SeoContentFor CV Search--
    public static SimpleCVSearch = 2;
    public static CVSearchByIndustry = 4;
    public static CVSearchByLocation = 6;
}